export const EXPLORE_SEARCH_WAIT_STEP_ID = 'exp-search-wait';

/** Full-page dim + search highlight while the search-wait step is active (not OK-dismissed). */
export const EXPLORE_SEARCH_SPOTLIGHT_CLASS = 'shepherd-explore-search-tour-spotlight';

/** Typing / autocomplete passthrough while the search tip is open (focus sync only). */
export const EXPLORE_SEARCH_INTERACTION_CLASS = 'shepherd-explore-search-interaction';

export function setExploreSearchSpotlightActive(active: boolean): void {
  document.body.classList.toggle(EXPLORE_SEARCH_SPOTLIGHT_CLASS, active);
}

export function setExploreSearchInteractionActive(active: boolean): void {
  document.body.classList.toggle(EXPLORE_SEARCH_INTERACTION_CLASS, active);
}

export function clearExploreSearchTourUi(): void {
  setExploreSearchSpotlightActive(false);
  setExploreSearchInteractionActive(false);
  resetExploreSearchTargetPadding();
}

export function resolveExploreSearchTarget(): HTMLElement | null {
  return document.querySelector('[data-tour="explore-search"]');
}

export function resetExploreSearchTargetPadding(): void {
  const root = resolveExploreSearchTarget();
  if (root) {
    root.style.paddingBottom = '';
  }
}
